import React from 'react';
import { useNavigate } from 'react-router-dom';
import { I } from '../icons-ds';
import { Empty } from '../ui';
import { MobileNav, useViewport } from '../layout';
import { PhraseCard } from './PhraseCard';
import { usePhrases } from '../lib/PhrasesContext';
import { useTheme } from '../lib/ThemeContext';
import type { Phrase } from '../lib/types';

export function FavoritesScreen() {
  const viewport = useViewport();
  const navigate = useNavigate();
  const isMobile = viewport === 'mobile';

  const { phrases, toggleFavorite } = usePhrases();
  const { layout } = useTheme();
  const favorites = phrases.filter((p) => p.favorite);
  const gridView = !isMobile && layout === 'grid';

  const open = (p: Phrase) => {
    navigate('/phrase/' + p.id);
  };

  return (
    <div style={{ minHeight: '100%', background: 'var(--bg-canvas)' }}>
      {isMobile && <MobileNav title="Favorites" onBack={() => navigate(-1)} backTitle="Back" />}

      <div style={{ padding: isMobile ? '0 16px 32px' : '24px 32px 48px', maxWidth: 980, margin: '0 auto' }}>
        {!isMobile && (
          <div style={{ marginBottom: 24 }}>
            <div className="t-largetitle" style={{ marginBottom: 4 }}>Favorites</div>
            <div className="t-subhead" style={{ color: 'var(--fg-secondary)' }}>
              {favorites.length} starred {favorites.length === 1 ? 'phrase' : 'phrases'} · keep your most-used templates one tap away
            </div>
          </div>
        )}

        {favorites.length === 0 ? (
          <Empty
            icon={<I.star size={28} />}
            title="Nothing starred yet"
            body="Tap the star on any phrase to pin it here for instant access."
          />
        ) : (
          <div
            style={
              gridView
                ? { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: 12 }
                : { display: 'flex', flexDirection: 'column', gap: 8 }
            }
          >
            {favorites.map((p) => (
              <PhraseCard
                key={p.id}
                phrase={p}
                onOpen={() => open(p)}
                onFavorite={() => toggleFavorite(p.id)}
                layout={gridView ? 'grid' : 'list'}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default FavoritesScreen;
